<template>
  <div class="design-tree">
    <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    components: {

    },
    data () {
      return {
        data:[{
          label: '所有资料',
          children: [{
            label: 'ICU5000 物联网边缘控制器 ',
          },{
            label: '温湿度传感器 ',
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    },
    computed: {

    },
    watch: {

    },
    created () {

    },
    mounted () {

    },
    destroyed () {

    },
    methods: {
      handleNodeClick(data) {
        console.log(data);
      }
    }
  }
</script>

<style scoped>
  .design-tree{
    height: 100%;
    background-color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ProductInformation/TheAside.vue